module.exports = __webpack_public_path__ + "img/new_logo.d5a20ae9.png";